import { fonts } from '@shared/tokens/fonts.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import * as stylex from '@stylexjs/stylex';
import { typography } from '@shared/tokens/typography.stylex';
import { palette } from '@shared/tokens/palette.stylex';

export const styles = stylex.create({
  addSegmentBtn: {
    paddingTop: '16px',
  },
  base: {
    display: 'flex',
    justifyContent: 'center',
  },
  textBtn: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
    textAlign: 'left',
  },
  steps: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
  },
  stepsTwo: {
    paddingTop: '24px',
  },
  stepThree: {
    height: '100%',
  },
  excelInput: () => ({
    width: '100%',
    height: '100%',
    padding: '32px 16px 32px 16px',
    gap: '8px',
    borderRadius: '8px 0px 0px 0px',
    border: '1px solid',
    borderColor: colors.tertiaryBorder,
    opacity: '0px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  }),
  excelText: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: anatomy['size-12'],
    textAlign: 'left',
    color: colors.tertiaryText,
  },
  withExcelBase: {
    display: 'flex',
    gap: '24px',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
  },
  backBtn: {},
  cancelBtn: {
    color: colors.primaryText,
  },
  acceptBtn: {
    color: colors.primaryInverseText,
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    marginTop: '24px',
    gap: '16px',
    padding: '16px',
    width: '530px',
    height: '290px',
    background: colors.ghostBackground,
    borderRadius: anatomy.borderRadiusM,
  },
  inputs: {
    display: 'flex',
    flexDirection: 'column',
    gap: '36px',
    paddingTop: '16px',
    ':not(#__unused__) > div > div': {
      height: '16px',
    },
  },
  stepsText: {
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: '12px',
    textAlign: 'left',
  },
  stepsDescription: {
    color: colors.tertiaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  importTargetGroup: {
    display: 'flex',
    padding: '12px 0px',
    alignItems: 'center',
    gap: anatomy['space-24'],
    alignSelf: 'stretch',
  },
  importTargetOption: {
    display: 'flex',
    padding: 'var(--space-no, 0px)',
    alignItems: 'flex-start',
    gap: anatomy['space-8'],
  },
  importTargetRadio: {
    display: 'flex',
    padding: '3px',
    alignItems: 'center',
    gap: '0px',
  },
  importTargetLabel: {
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeBody-3'],
    fontWeight: typography.fontWeighRegular,
    lineHeight: '24px',
  },
  firstStepText: {
    paddingTop: '24px',
  },
  flex: {
    display: 'flex',
    gap: '16px',
    ':not(#__unused__) > div > div': {
      height: '16px',
    },
  },
  modalContainer: (isGuest: boolean) => ({
    minHeight: isGuest ? '308px' : '360px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    height: '100%',
    width: '100%',
  }),
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  container: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '16px',
    alignSelf: 'stretch',
    marginTop: '24px',
    marginBottom: '16px',
    flexGrow: '1',
  },
  checkboxWithName: {
    display: 'flex',
    padding: '8px 12px',
    alignItems: 'flex-start',
    gap: '8px',
    width: '100%',
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    cursor: 'pointer',
    border: 'none',
    background: 'none',
  },
  participants: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    marginTop: '16px',
    overflowX: 'hidden',
    width: '100%',
  },
  participant: {
    flex: '1 0 0',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    maxHeight: '40px',
    color: colors.primaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  content: {
    display: 'grid',
    gridTemplateColumns: '320px 1fr',
    flexDirection: 'column',
    alignItems: 'stretch',
    gap: '24px',
    height: '100%',
    width: '100%',
  },
  participantsColumn: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    flexGrow: '1',
    position: 'relative',
  },
  inputWithSelectedParticipant: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '8px',
    alignSelf: 'stretch',
    width: '100%',
  },
  input: {
    ':not(#__unused__) > div > div': {
      height: '16px',
    },
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
  },
  remoteStatus: {
    fontSize: typography['fontSizeCaption-2'],
    lineHeight: '12px',
    color: palette['grey-700'],
    background: palette['grey-100'],
    borderRadius: anatomy.borderRadiusRound,
    padding: '4px 8px',
    display: 'inline-block',
    marginLeft: '8px',
  },
  blockAllList: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    flexGrow: '1',
    overflowX: 'hidden',
    width: '100%',
  },
  preloaderCircular: {
    margin: '0 auto',
  },
  allList: (isGuest: boolean) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    maxHeight: isGuest ? '208px' : '260px',
    width: '100%',
  }),
  virtualScrollContainer: {
    width: '510px',
    height: '260px',
    overflow: 'auto',
    position: 'relative',
    alignSelf: 'stretch',
  },
  virtualScrollContainerGuest: {
    height: '208px',
  },
  virtualInnerContainer: {
    position: 'relative',
  },
  virtualContentContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    transform: 'translateY(var(--virtual-offset, 0px))',
  },
  virtualInnerContainerDynamic: {
    height: 'var(--virtual-height, 0px)',
  },
  position: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-2'],
    fontStyle: 'normal',
    fontWeight: typography['fontWeighRegular'],
    lineHeight: typography['lineHeightBody-3'],
    color: colors['secondaryText'],
    textAlign: 'center',
  },

  reminderFreeForm: {
    marginTop: '8px',
    color: colors.errorText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    fontStyle: 'normal',
    fontWeight: typography.fontWeighRegular,
    lineHeight: typography['lineHeightCaption-1'],
  },
  filterModal: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px 7px 8px 7px',
    gap: '8px',
    background: 'black',
    cursor: 'pointer',
    fontSize: '14px',
    borderRadius: '8px',
    marginLeft: 'auto',
    height: '36px',
    border: '1px solid transparent',
  },

  filterModalActive: {
    background: ' var(--background-hover, rgba(29, 37, 45, 0.05))',
    border: '1px solid var(--border-primary, rgba(29, 37, 45, 0.40))',
  },
  badgeCount: {
    position: 'absolute',
    top: '-5px',
    right: '-4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: palette['bronze-200'],
    color: palette['grey-950'],
    borderRadius: '50%',
    padding: '2px 6px',
    fontSize: typography['fontSizeCaption-2'],
    width: '16px',
    height: '16px',
    fontFamily: fonts.din2014Demi,
    fontWeight: typography.fontWeighRegular,
  },
  dateContainer: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
    gap: '4px',
    alignSelf: 'stretch',
    flexWrap: 'wrap',
    color: colors.secondaryText,
  },
  dateContent: {
    display: 'flex',
    padding: '4px 4px 4px 8px',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '8px',
    borderRadius: 'var(--border-radius-xs, 4px)',
    background: 'var(--background-ghost, #F5F5F5)',
    fontSize: '12px',
    fontFamily: fonts.din2014Regular,
    fontWeight: typography.fontWeighRegular,
    fontStyle: 'normal',
    lineHeight: typography['lineHeightCaption-2'],
  },
  clearBtn: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '16px',
    height: '16px',
  },
  loaderOverlay: {
    position: 'absolute',
    inset: 0,
    zIndex: 10,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  loaderContainer: {
    position: 'relative',
    minHeight: '308px',
  },
  textError: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '16px',
    alignSelf: 'stretch',
    paddingTop: '46px',
    fontFamily: fonts.din2014Regular,
    color: colors.tertiaryText,
  },
  tabsContainer: {
    width: '100%',
    height: '44px',
    display: 'grid',
    gridTemplateColumns: '1fr max-content',
  },
  participantCount: {
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeBody-4'],
    lineHeight: '20px',
    padding: '12px',
    color: colors.secondaryText,
    height: '45.5px',
    borderBottom: `1px solid ${colors.secondaryBorder}`,
  },

  treeContainer: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: anatomy['space-12'],
    alignSelf: 'stretch',
    boxSizing: 'border-box',
    width: '100%',
    overflow: 'auto',
    height: '374px',
    maxWidth: '528px',
    fontFamily: fonts.din2014Regular,
    padding: '0 20px',
  },
  main: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    flex: '1 0 0',
    width: '100%',
    borderLeft: `1px solid ${colors.tertiaryBorder}`,
    paddingLeft: '7px',
  },

  departmentHeader: {
    display: 'flex',
    padding: '8px 12px',
    alignItems: 'flex-start',
    gap: anatomy['space-24'],
    width: '100%',
    alignSelf: 'stretch',
  },

  departmentHeaderContent: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    gap: anatomy['space-8'],
    width: '100%',
  },
  chevronSpacer: {
    width: 20,
    height: 20,
  },

  checkbox: {
    display: 'flex',
    alignItems: 'center',
  },
  loader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  emptyState: {
    display: 'flex',
    color: colors.secondaryText,
    fontFamily: fonts.din2014Regular,
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
  },
  editButton: {
    background: 'none',
    border: 'none',
    padding: 0,
    cursor: 'pointer',
  },
});
